import { render, staticRenderFns } from "./deletepop.vue?vue&type=template&id=27a8a42c&scoped=true"
import script from "./deletepop.vue?vue&type=script&lang=js"
export * from "./deletepop.vue?vue&type=script&lang=js"
import style0 from "./deletepop.vue?vue&type=style&index=0&id=27a8a42c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a8a42c",
  null
  
)

export default component.exports